export enum PasswordValidationEnum {
  MinLength = 6,
  MaxLength = 16,
}
